module.exports = __webpack_public_path__ + "static/media/egg404.011afb74.png";